import React, { useState } from 'react';
import { Button, Space, Popconfirm } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import VariableSelector from './VariableSelector';
import VariableSettingsModal from './VariableSettingsModal';
import { useTheme } from '../../context/ThemeContext';

const VariablesBar = ({ variables, variableDefinitions, onVariableChange, onVariableUpdate, onVariableDelete }) => {
  const { isDark } = useTheme();
  const [modalVisible, setModalVisible] = useState(false);
  const [editingVariable, setEditingVariable] = useState(null);

  const handleEditVariable = (variable) => {
    setEditingVariable(variable);
    setModalVisible(true);
  };

  const handleSaveVariable = (updatedVariable) => {
    onVariableUpdate(updatedVariable);
    setModalVisible(false);
    setEditingVariable(null);
  };

  return (
    <div
      style={{
        padding: '8px 16px',
        minHeight: 40,
        display: 'flex',
        alignItems: 'center',
        borderBottom: isDark ? '1px solid #30363d' : '1px solid #f0f0f0',
        background: isDark ? '#161b22' : '#fafafa',
      }}
    >
      <Space wrap size="small">
        {(variableDefinitions || []).map(varDef => (
          <div
            key={varDef.name}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '4px 8px',
              borderRadius: 6,
              background: isDark ? '#21262d' : '#f0f0f0',
            }}
          >
            <VariableSelector
              variable={varDef}
              value={variables?.[varDef.name]}
              onChange={(value) => onVariableChange(varDef.name, value)}
              onEdit={() => handleEditVariable(varDef)}
            />
            {onVariableDelete && (
              <Popconfirm
                title="Delete variable"
                description={`Remove "${varDef.label || varDef.name}"? Panels using this variable may need updates.`}
                onConfirm={() => onVariableDelete(varDef.name)}
                okText="Delete"
                cancelText="Cancel"
                okButtonProps={{ danger: true }}
              >
                <CloseOutlined
                  style={{
                    cursor: 'pointer',
                    color: isDark ? '#8b949e' : '#8c8c8c',
                    fontSize: 12,
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#ff4d4f';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = isDark ? '#8b949e' : '#8c8c8c';
                  }}
                />
              </Popconfirm>
            )}
          </div>
        ))}
        
        <Button 
          icon={<PlusOutlined />} 
          onClick={() => {
            setEditingVariable(null);
            setModalVisible(true);
          }}
        >
          Add Variable
        </Button>
      </Space>

      <VariableSettingsModal
        visible={modalVisible}
        variable={editingVariable}
        onSave={handleSaveVariable}
        onClose={() => {
          setModalVisible(false);
          setEditingVariable(null);
        }}
      />
    </div>
  );
};

export default VariablesBar;